import 'semantic-ui-css/semantic.min.css'
import { React, useEffect, useRef, useState } from 'react';
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import { Grid , Segment , List , Header, Container , Image } from 'semantic-ui-react';
//const pub = process.env.PUBLIC_URL
import './translations/i18n';
import { useTranslation  } from 'react-i18next';
import EpubHeader from './assets/epub-header-background.webp'
import logoMediaLibrary_en from './assets/no-image-logo-media-library-logo-960x192_en.png';
import logoMediaLibrary_nl from './assets/no-image-logo-media-library-logo-960x192_nl.png';
import logoAUAS_en from './assets/artevelde-logo-467x192_en.png';
import logoAUAS_nl from './assets/artevelde-logo-467x192_nl.png';

const languages = [
    { lang : 'nl' , label : 'Nederlands' , flag : 'be' , title  : 'Arteveldehogeschool Mediatheken - Epublicaties' },
    { lang : 'en' , label : 'English' , flag : 'gb' , title : 'Artevelde UAS Libraries - Epublications'}]

const ApplicationFooter = ( {version}) => {
    const { t , i18n } = useTranslation();
    const [ locale , setLocale ] = useState(localStorage.getItem('i18nextLng'))
    i18n.on('languageChanged', (lng) => setLocale(lng))
    const logoMediaLibrary = (locale === 'nl') ? logoMediaLibrary_nl : logoMediaLibrary_en;
    const logoAUAS = (locale === 'nl') ? logoAUAS_nl : logoAUAS_en;


    return (
        <Segment inverted vertical style={{ padding: '5em 0em' , marginTop : '5rem'}}>
        <Container>
        <Grid divided inverted stackable
        verticalAlign='middle' >
            <Grid.Row>
            <Grid.Column width={3}>
                <Image 
                    src={logoAUAS} 
                    as='a'
                    href='https://arteveldehogeschool.be/'
                    target='_blank'
                />
                <Image 
                    src={logoMediaLibrary} 
                    as='a'
                    href='https://mediatheken.arteveldehogeschool.be/'
                    target='_blank'    
                />
            </Grid.Column>
            <Grid.Column width={7}>
                <Header inverted as='h4' content={`${t('MainTitle')} v${version}`} />
                <p>
                    {t('epubFooter')}
                </p>
            </Grid.Column>
            </Grid.Row>
            
            
        </Grid>
        </Container>
    </Segment>
    );
}

export default ApplicationFooter;